import {SaveState} from '@deliveriesondemand/dod-data';
import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import Button from '-/components/general/Button';
import {bounce, spin} from '-/styles/utils';

const styles = () => ({
    save: {
        ...bounce()
    },
    saving: {
        ...spin()
    }
});

class SubmitButton extends Component {
    static propTypes = {
        onClick: PropTypes.func
    };

    static defaultProps = {
        onClick: () => {}
    };

    render() {
        const {saveState, onClick, classes = {}, disabled = false} = this.props;
        let cls, innerHtml;

        switch (saveState) {
            case SaveState.Saved:
                cls = classNames('fa fa-floppy-o', classes.save);
                innerHtml = <i className={cls} />;
                break;
            case SaveState.Saving:
                cls = classNames('fa fa-spinner', classes.saving);
                innerHtml = <i className={cls} />;
                break;
            case SaveState.NotSaved:
            case SaveState.Failed:
                innerHtml = <span>Submit Application</span>;
                break;
        }

        return (
            <Button disabled={disabled} btnStyle="alternate" onClick={onClick}>
                {innerHtml}
            </Button>
        );
    }
}

const mapStateToProps = state => {
    return {
        saveState: state.api.saveStateFinalSubmit
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(SubmitButton));
